import { FORM_OBJECT_TYPE } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { IN, GTE } from 'marketing-platform-lib/utils/filters';

// Custom views are number based, hence the need for `\\d+`
export const MANAGE_URL_REG = new RegExp('^/forms/[0-9]+/views/(all_forms|published_forms|forms_with_submissions|non_hubspot_forms|\\d+)?$');
export const FOLDER_URL_REG = new RegExp('^/forms/[0-9]+/folders(?:/\\d+)?$');
export const FORMS_OBJECT_TYPE = '0-28';
export const APPLICATION_ID = 'forms';
export const NAMESPACE = 'FORMS';
export const ALL_FORMS_VIEW_NAME = 'all_forms';
export const PUBLISHED_FORMS_VIEW_NAME = 'published_forms';
export const FORMS_WITH_SUBMISSIONS_VIEW_NAME = 'forms_with_submissions';
export const NON_HUBSPOT_FORMS_VIEW_NAME = 'non_hubspot_forms';
export const QUICK_FETCH_VIEWS = [ALL_FORMS_VIEW_NAME, PUBLISHED_FORMS_VIEW_NAME, FORMS_WITH_SUBMISSIONS_VIEW_NAME, NON_HUBSPOT_FORMS_VIEW_NAME];
export const ALL_FORMS_VIEW_FILTERS = [IN('hs_form_type', ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT'])];
export const PUBLISHED_FORMS_VIEW_FILTERS = [IN('hs_status', ['PUBLISHED']), IN('hs_form_type', ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT'])];
export const FORMS_WITH_SUBMISSIONS_VIEW_FILTERS = [GTE('hs_form_submissions', 1), IN('hs_form_type', ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT'])];
export const NON_HUBSPOT_FORMS_VIEW_FILTERS = [IN('hs_form_type', ['CAPTURED'])];
export const DEFAULT_FILTERS = [IN('hs_form_type', ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT'])];
export const DEFAULT_SORTS = [{
  order: 'DESC',
  property: 'hs_created_at'
}];
export const ALL_FORMS_VIEW_SORTS = [{
  order: 'DESC',
  property: 'hs_updated_at'
}];
export const PUBLISHED_FORMS_VIEW_SORTS = [{
  order: 'DESC',
  property: 'hs_updated_at'
}];
export const NON_HUBSPOT_FORMS_VIEW_SORTS = [{
  order: 'DESC',
  property: 'hs_form_submissions'
}];
export const FORMS_WITH_SUBMISSIONS_VIEW_SORTS = [{
  order: 'DESC',
  property: 'hs_form_submissions'
}];
export const HIDDEN_FILTER = {
  filterGroups: [{
    filters: [IN('hs_form_type', ['CAPTURED', 'HUBSPOT', 'FLOW', 'BLOG_COMMENT'])]
  }]
};
export const CRM_SEARCH_REQUEST_DEFAULT_OPTIONS = {
  count: 25,
  objectTypeId: FORM_OBJECT_TYPE,
  requestOptions: {
    allPropertiesFetchMode: 'latest_version',
    includeAllProperties: true
  },
  filterGroups: HIDDEN_FILTER.filterGroups,
  associationPreviews: {},
  sorts: [{
    order: 'DESC',
    property: 'hs_updated_at'
  }],
  offset: 0,
  query: ''
};